import React, { useRef } from 'react'
import { CmsDataFetchStatus } from '@jarvis/olex-content-management'
import useContentStack from '../hooks/useContentStack'
import classes from './AlignmentHelpModal.module.scss'
import { ContentStackTypes } from '../store/Constants'
import Modal from '@veneer/core/dist/esm/scripts/modal'

export const AlignmentHelpModal = ({ open, onClose }) => {
  const modalContentRef = useRef(null)

  const setModalContentRef = (element) => {
    modalContentRef.current = element
    if (element && open) {
      element.scrollTop = 0
    }
  }

  const parseContentStackModalData = (data) => {
    return {
      header: data?.header,
      subheader: data?.content[0]?.copy?.copy || '',
      errorIndicator: data?.content[1]?.copy?.copy || '',
      aftermathContent: data?.content[2]?.copy?.copy || ''
    }
  }

  const { status, pageData } = useContentStack(
    ContentStackTypes.modal_alignment_help,
    parseContentStackModalData
  )

  if (status === CmsDataFetchStatus.LOADING) {
    return <></>
  }

  return (
    <Modal
      className={classes.alignmentHelpModal}
      show={open}
      closeButton
      expanded={true}
      maxWidth="1014px"
      id="alignment-modal"
      onClose={onClose}
      portal
      customStyle={{
        maxHeight: '90vh',
        height: 'auto',
        overflow: 'hidden'
      }}
    >
      <div className={classes.modalContent}>
        <div ref={setModalContentRef} className={classes.content}>
          <h4 className={classes.modalTitle}>{pageData?.header}</h4>
          <div
            className={classes.subheader}
            dangerouslySetInnerHTML={{
              __html: pageData?.subheader
            }}
          />
          <div
            className={classes.errorIndicator}
            dangerouslySetInnerHTML={{
              __html: pageData?.errorIndicator
            }}
          />
          <div
            className={classes.aftermathContent}
            dangerouslySetInnerHTML={{
              __html: pageData?.aftermathContent
            }}
          />
        </div>
      </div>
    </Modal>
  )
}
